import { render, staticRenderFns } from "./NutritionWorkshop.vue?vue&type=template&id=cf092684"
import script from "./NutritionWorkshop.vue?vue&type=script&lang=js"
export * from "./NutritionWorkshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports